import AlcoholCalcNavbar from "../../components/Navbars/AlcoholCalcNavbar";
import {Link} from "react-router-dom";

const AlcoholCalcIndex = () => {
    return <>
        <AlcoholCalcNavbar/>
        <div className="section pb-0 section-components">
            <div className="container mb-5">
                <div className="section features-1">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-8 mx-auto text-center">
                                <h3 className="display-3"></h3>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-8 mx-auto text-center mb-5">
                                <p className="lead">Calculators of Ethanol Kinetics</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6 mb-5">
                                <div className="info">
                                    <h6 className="info-title text-uppercase">Calculator of Ethanol Blood Kinetics Post
                                        Single Oral Alcohol Intake</h6>
                                    <a href="/alcohol-calc-v1"
                                       className="text-primary"> Go to calculations
                                        <i className="ni ni-bold-right text-primary"></i>
                                    </a>
                                </div>
                            </div>
                            <div className="col-md-6 mb-5">
                                <div className="info">
                                    <h6 className="info-title text-uppercase">Multi-Dose Oral Ethanol Blood Kinetics
                                        Calculator </h6>
                                    <a href="/alcohol-calc-v3"
                                       className="text-primary"> Go to calculations
                                        <i className="ni ni-bold-right text-primary"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6 mb-5">
                                <div className="info">
                                    <h6 className="info-title text-uppercase">Multi-Dose Oral Ethanol Body Fluids
                                        Kinetics Calculator</h6>
                                    <a href="/alcohol-calc-v6"
                                       className="text-primary"> Go to calculations
                                        <i className="ni ni-bold-right text-primary"></i>
                                    </a>
                                </div>
                            </div>
                            <div className="col-md-6 mb-5">
                                <div className="info">
                                    <h6 className="info-title text-uppercase">Calculator of Body Ethanol Kinetics
                                        Following Single-Dose Oral Alcohol Intake </h6>
                                    <a href="/alcohol-calc-v7"
                                       className="text-primary"> Go to calculations
                                        <i className="ni ni-bold-right text-primary"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6 mb-5">
                                <div className="info">
                                    <h6 className="info-title text-uppercase">Reduction Factor Uncertainty Calculator</h6>
                                    <a href="/alcohol-calc-v2"
                                       className="text-primary"> Go to calculations
                                        <i className="ni ni-bold-right text-primary"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
        }
        export default AlcoholCalcIndex;